import { render } from "./gestionreservaadm.vue?vue&type=template&id=073d7eac&scoped=true"
import script from "./gestionreservaadm.vue?vue&type=script&lang=js"
export * from "./gestionreservaadm.vue?vue&type=script&lang=js"

import "./gestionreservaadm.vue?vue&type=style&index=0&id=073d7eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073d7eac"]])

export default __exports__